import { combineReducers } from 'redux'
import auth from './auth.js'
import isDirty from './isDirty.js'

export default combineReducers({ auth, isDirty })
